<template>
  <div>
    <template v-for="(documento,i) in comprador.documentacion">
      <div v-if="!esDocumentacionExtra(documento.carpeta)" 
        :class="claseSeccionValidacionDocumento(documento, revisando || documentacionRechazada)"
        :key="'section'+documento.carpetaId"
      >
        <v-layout mb-3 :key="'label'+documento.carpetaId">
          <label 
            class="theme--light v-label"
            :class="!documentosValidos[i] ? 'error--text' : ''"
            v-if="!esDocumentacionExtra(documento.carpeta)"
          >
            {{getDescripcionTraducida(documento.carpeta.descripcion)}}
          </label>
        </v-layout>
        <v-layout 
          v-if="!esDocumentacionExtra(documento.carpeta)"
          mb-3 wrap :key="'uploader'+documento.carpetaId">
          <v-flex
            xs12 sm12 md12 lg12
            :mb-2="(revisando || (!revisando && documento.validado === false))"
          >
            <FileUploader
              style="height:168px"
              :maxNum="10"
              v-model="documento.documento"
              :deletable="!documentacionVer && !revisando && !guardando && !(documento.validado && (revisando || documentacionRechazada))"
              :disabled="documentacionVer || revisando || guardando || (documento.validado && documentacionRechazada)"
              @input="inputDocumento(i)"
            />
          </v-flex>
        </v-layout>
        <v-flex shrink v-if="revisando">
          <v-btn
            block
            color="primary"
            @click="documento.validado = !documento.validado"
            hide-details
          >
          {{documento.validado ? $t('reservas.documentacion.rechazarDoc') : $t('reservas.documentacion.validarDoc')}}
          </v-btn>
        </v-flex>
      </div>
    </template>
  </div>
</template>
<script>
import rules from '@/mixins/rules'
import MixinComprador from '@/mixins/comprador'
import MixinDocumentacion from '@/mixins/documentacion'
import MixinEstadoDocumentacion from '@/mixins/estadosReserva/estadoDocumentacion'
import FileUploader from '@/components/generic/fileUploader/FileUploader'

export default {
  mixins: [rules, MixinComprador, MixinDocumentacion, MixinEstadoDocumentacion],
  props: {
    comprador: {
      type: Object,
      required: true
    },
    guardando: {
      type: Boolean,
      default: false
    },
    revisando: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FileUploader
  },
  data () {
    return {
      documentosValidos: []
    }
  },
  created () {
    this.documentosValidos = this.documentacionFiltrada(this.comprador).map(() => true)
  },
  computed: {
    cantidadDocumentos () {
      let i = 0
      this.comprador.documentacion.forEach(x => {
        i += x.documento.length
      })
      return i
    }
  },
  methods: {
    comprobarDocumentacion () {
      for (let i = 0; i < this.comprador.documentacion.length; i++) {
        let documentacionValidada = true
        if (!this.revisando && this.comprador.documentacion[i].validado === false) {
          documentacionValidada = (this.esDocumentacionExtra(this.comprador.documentacion[i].carpeta) && this.comprador.documentacion[i].documento.length === 0) || this.comprador.documentacion[i].documento.some(x => !x.id)
        }
        let documentacionValida = true
        if (this.esDocumentacionExtra(this.comprador.documentacion[i].carpeta)) {
          documentacionValida = this.comprador.documentacion[i].documento.length === 0 || this.comprador.documentacion[i].documento.filter(x =>
            (x.id_temporal && x.status === 'SUCCESS') || x.id
          ).length > 0
        } else if (this.esDocumentacionMorosidad(this.comprador.documentacion[i].carpeta)) {
          if (this.moduloOrden.documentoMorosidadOpcional) {
            documentacionValida = this.comprador.documentacion[i].documento.length === 0 || this.comprador.documentacion[i].documento.filter(x =>
              (x.id_temporal && x.status === 'SUCCESS') || x.id
            ).length > 0
          } else {
            documentacionValida = this.comprador.documentacion[i].documento.filter(x =>
              (x.id_temporal && x.status === 'SUCCESS') || x.id
            ).length > 0
          }
        } else {
          documentacionValida = this.comprador.documentacion[i].documento.filter(x =>
            (x.id_temporal && x.status === 'SUCCESS') || x.id
          ).length > 0
        }
        this.$set(this.documentosValidos, i, documentacionValidada && documentacionValida)
      }
      if (this.comprador.titular) {
        this.$emit('comprobarExtra', this.documentosValidos)
      }
      return !this.documentosValidos.some(x => !x)
    },
    mostrarTextoValidado (documentacion) {
      return documentacion && documentacion.documento && (documentacion.documento.length !== 0 || documentacion.validado !== null) && documentacion.validado === false
    },
    inputDocumento (i) {
      this.comprador.documentacion[i].validado = this.estadoValidacionDocumento(this.comprador.documentacion[i].documento, this.revisando, this.comprador.documentacion[i].carpeta)
      return this.comprobarDocumento(i)
    },
    comprobarDocumento (i) {
      let documentacionValida = false
      if (this.esDocumentacionMorosidad(this.comprador.documentacion[i].carpeta) && this.moduloOrden.documentoMorosidadOpcional) {
        documentacionValida = this.comprador.documentacion[i].documento.length === 0
      }
      documentacionValida = documentacionValida || this.comprador.documentacion[i].documento.filter(x =>
        (x.id_temporal && x.status === 'SUCCESS') || x.id
      ).length > 0
      this.$set(this.documentosValidos, i, documentacionValida)
      return this.documentosValidos[i]
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~vuetify/src/stylus/settings/_colors'

.fullWidth.v-input--selection-controls .v-input__control
  width: 100% !important

</style>



// WEBPACK FOOTER //
// src/components/reservas/documentacion/DocumentacionComprador.vue